import { PaymentMethod } from "@/types/payment";

export function getLastFourDigitsFromPaymentMethod(
  paymentMethod: PaymentMethod,
) {
  if (paymentMethod.bankName) {
    return paymentMethod.accountNumberLast4;
  }
  return (
    paymentMethod.last4 ||
    (paymentMethod.description ? paymentMethod.description.split(" ")[1] : null)
  );
}
